const SVG_XLINK_NAMESPACE_URI = "http://www.w3.org/1999/xlink";
const DATA_URI_IMAGE_MIME_PATTERN = /^data:image\/[^;,]+/i;

export function shouldRemoveImageHref(
  href: string | null | undefined,
): boolean {
  if (href == null || typeof href !== "string") {
    return true;
  }
  if (href === "") {
    return true;
  }
  if (href.startsWith("data:") && !DATA_URI_IMAGE_MIME_PATTERN.test(href)) {
    return true;
  }
  return false;
}

export function sanitizeSvgImagesForPdf(svg: SVGElement): void {
  const images = Array.from(svg.querySelectorAll("image"));
  for (const el of images) {
    const href =
      el.getAttribute("href") ??
      el.getAttributeNS(SVG_XLINK_NAMESPACE_URI, "href");
    if (!shouldRemoveImageHref(href)) {
      continue;
    }
    el.parentNode?.removeChild(el);
  }
}
